export default __webpack_public_path__ + "media/images/banner/banner-31-492c95ac263a66d0dcc065d298e6b87f.jpg";